module.exports = __webpack_public_path__ + "img/shui.c32be7a0.png";